import React, { createContext, useContext } from 'react';

// Tab indices match the order in App.tsx. Update both files together.
export const TAB_PIPELINE_MANAGER = 0;
export const TAB_UI_MANAGER = 1;
export const TAB_VIEW_MANAGER = 2;
export const TAB_VIEW_TEMPLATE_MANAGER = 3;
export const TAB_MODEL_MANAGER = 4;
export const TAB_PIVOT_MANAGER = 5;
export const TAB_AI_ASSISTANT = 6;

interface TabNavigationContextValue {
  activeTab: number;
  setActiveTab: (index: number) => void;
}

const TabNavigationContext = createContext<TabNavigationContextValue | null>(null);

interface ProviderProps {
  activeTab: number;
  setActiveTab: (index: number) => void;
  children: React.ReactNode;
}

export function TabNavigationProvider({ activeTab, setActiveTab, children }: ProviderProps) {
  return (
    <TabNavigationContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </TabNavigationContext.Provider>
  );
}

export function useTabNavigation(): TabNavigationContextValue {
  const ctx = useContext(TabNavigationContext);
  if (!ctx) {
    throw new Error('useTabNavigation must be used within a TabNavigationProvider');
  }
  return ctx;
}
